/**
 * Feature flags convention: go/frontend-feature-flags
 */
import { expValEquals, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { ff, getFeatureFlagValue } from '@atlassian/jira-feature-flagging';

export const isNewAutomationMenuEnabled = () =>
	ff('jsw-replace-automationmenu-with-new-context-aware-menu_rltpk');

export const isDevStatusOnCardsDisabled = () => ff('jsw.killswitch.dev-status-on-cards');

export const getBoardPollingInterval = () =>
	getFeatureFlagValue('jsw.nextgen.board.polling.interval', 60000);

export const getBoardJirtDebounceInterval = () =>
	getFeatureFlagValue('jsw.nextgen.board.jirt.debounce.interval', 500);

export const getBoardJirtJitter = () => getFeatureFlagValue('jsw.nextgen.board.jirt.jitter', 500);

export const isErrorTrackingEnabledWithSentry = () => ff('fe.platform.error.tracking.enabled');

export const isPrefetchIssueDataByColumnLimitEnabled = () =>
	ff('jsw-agile-board-prefetch-issue-data-by-column-limit');

export const isSyntheticTenant = () => ff('jsw.pollinator.tenants');

// <pyamada>
export const isLongTasksRefactorEnabled = () => ff('jsw.long-tasks-refactor');
// </pyamada>

// <whua>
export const isAlternateTTIMeasurementEnabled = () => ff('jsw-measure-tti-alternate');
// </whua>

export const emitApdexOnAnimationFrame = () =>
	ff('jsw.perf.board-backlog-emit-apdex-on-animation-frame');

export const INCREMENT_PLANNING_BOARD_M1 =
	'com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1';

export const isIncrementPlanningBoardM1Enabled = () => ff(INCREMENT_PLANNING_BOARD_M1);

// eslint-disable-next-line jira/ff/inline-usage
export const isTailoredViewExperimentEnabled = () =>
	expValEquals('jsw_additional_card_fields_in_view_settings', 'cohort', 'variation');

// <tjoy>
// eslint-disable-next-line jira/ff/inline-usage
export function isInAddPeopleButtonOpenTMPControlCohort(): boolean {
	return expValEquals('open_invite_for_open_tmp_projects', 'cohort', 'control');
}
// </tjoy>

// <fzeng>
export const isViewSettingAsPanelExpEnabledWithNoExposure = () => {
	const [expConfig] = UNSAFE_noExposureExp('jsw_additional_card_fields_in_view_settings');
	return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
// </fzeng>

// <hyustiawan>
export const isIssueTypeInContextExperimentEnabled = () => {
	const [expConfig] = UNSAFE_noExposureExp('jsw_config_in_context_issue_types_m2');
	return (
		// kill switch
		ff('config-in-context-issue-type-m2-flag_bddyq') &&
		// check if user is in test / experimentation cohort
		expConfig.get('inlineIssueTypeConfigEnabled', false)
	);
};

// </hyustiawan>

// <szeng>
export const isMinimizeLinkedIssuesStatsRequestsEnabled = () =>
	ff('jsw-minimise-linked-issues-stats-requests_pn6em');
// </szeng>
